/**
 * @file RingProgressbar component
 */

import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'RingProgressbar';

class RingProgressBar extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		const progressText = SelectorEngine.findOne('.progress-text', this._element);
		const actualValue = Manipulator.getDataAttribute(this._element, 'actual-value');
		const totalValue = Manipulator.getDataAttribute(this._element, 'total-value');

		// Ensure progressValue is within the range of 0 to 100
		const progressValue = Math.min(100, Math.max(0, (actualValue / totalValue) * 100));

		// Set the percentage variable in the style
		this._element.style.setProperty('--percentage', progressValue);

		// Update the text content
		progressText.textContent = actualValue;
	}
}
export default RingProgressBar;
